import React, { useState } from "react";
import "./style.scss";
import FederalTaxSetup from "../../EmployeeOnboarding/EmployeeOnboardingForms/FederalTaxSetup";
import SignedDocuments from "../../EmployeeOnboarding/EmployeeOnboardingForms/SignDocumentDetails/index";
import { Modal } from "react-bootstrap";
import Loader from "../../../components/Loader";
import { postData } from "../../../api";

const FederalTaxTab = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [signature, setSignature] = useState();
  const [signatureCheckbox, setSignatureCheckbox] = useState(false);
  const [signed, setSigned] = useState(false);
  const [form, setForm] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const { federalList, federalTaxData, userId, setStep, getProfileUserById } =
    props;
  const data = federalTaxData ? federalTaxData : {};
  // Function to fetch document data before opening the modal
  const fetchDocumentData = async (formData) => {
    setLoadingModal(true);
    try {
      if (formData && formData.uuid && formData.stage) {
        let obj = {
          stage: formData.stage,
          uuid: formData.uuid,
        };
        const res = await postData("get-form-pdf-url", {}, obj);
        if (res?.status === true) {
          setDocumentData(res?.data);
        }
      }
    } catch (err) {
      console.error("Error fetching document data:", err);
    } finally {
      setLoadingModal(false);
      setModalShow(true);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (signature && signatureCheckbox) {
      setErrors({});
      setSignatureCheckbox(false);
      setSignature("");
      const formData = {
        signature,
        signatureCheckbox,
      };
      setSigned(true);
    } else {
      setErrors({
        signature: !signature ? "Signature is required" : "",
        signatureCheckbox: !signatureCheckbox ? "Please check the box" : "",
      });
    }
  };
  return (
    <React.Fragment>
      {loadingModal ? (
        <Loader />
      ) : (
        <React.Fragment>
          <FederalTaxSetup
            modalShow={modalShow}
            setModalShow={setModalShow}
            profileTab={true}
            federalList={federalList}
            data={data}
            userId={userId}
            form={form}
            setForm={setForm}
            loadingModal={loadingModal}
            setLoadingModal={setLoadingModal}
            fetchDocumentData={fetchDocumentData}
            getProfileUserById={getProfileUserById}
          />
          <Modal
            show={modalShow}
            onHide={() => {
              getProfileUserById(userId);
              setModalShow(false);
            }}
            className="federal-tax-modal"
          >
            <Modal.Body>
              <SignedDocuments
                profileTab={true}
                form={form}
                documentData={documentData}
                setModalShow={setModalShow}
                setStep={setStep}
                userId={userId}
                getProfileUserById={getProfileUserById}
              />
            </Modal.Body>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default FederalTaxTab;
